import { render } from "./AddBlock.vue?vue&type=template&id=2f2cd12c&scoped=true"
import script from "./AddBlock.vue?vue&type=script&lang=js"
export * from "./AddBlock.vue?vue&type=script&lang=js"

import "./AddBlock.vue?vue&type=style&index=0&id=2f2cd12c&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2cd12c"]])

export default __exports__